<template>
  <!--绝对不要在此处加<keep-alive>,谁加谁维护报价 !-->
  <router-view v-if="isRouterAlive"></router-view>
</template>
<script>
import api from '@/api/api.js'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  created() {
    const routerList = ['/motor/baseInfo', '/motor/personInfo', '/motor/motorQuote', '/motor/motorSupplementary', '/motor/carModelList', '/motor/motorClause']
    const newPath = this.$route.path
    if (routerList.indexOf(newPath) !== -1) {
      this.$router.push({ name: 'BaseInfo' })
    }
    // this.getConfigList()
  },
  mounted () {
    let URL = window.location.href
    let receive = URL.split('#/')[1]
    if (receive.split('/')[0] === 'car') {
      document.title = '车险投保'
    }
  },
  watch: {
    $route (to, from) {
      if (to.path.split('/')[1] === 'car') {
        document.title = '车险投保'
      }
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    getConfigList() {
      this.$http.post(api.getConfigList, { configType: '紫属保' }).then(res => {
        if (res.data.rtnCode === '0000') {
          res.data.configList.forEach(item => {
            if (item.configCode === 'HEADER_FLAG') { // 图片token请求头修改的开关，1开0关
              console.log(item, 'HEADER_FLAG')
              const isTokenShow = item.configValue === '1'
              this.$store.commit('set_isImgToken', isTokenShow)
              console.log(isTokenShow, '图片token')
              console.log(this.$store.state.isImgToken, '图片isImgToken')
            }
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="scss">
  body {
    background: #F7F6F9;
  }

  input {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue